import { TableField } from "../../table-field";

const validations = {
    key: "validations",
    label: "Validação",
    tdClass: ["align-middle", "col-actions", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const criterioIdItem: TableField = {
    key: "criterioIdItem",
    label: "ID",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const criterioDs: TableField = {
    key: "criterioDs",
    label: "Critério",
    tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
    thClass: ["text-center", "quebrarPorPalavra"],
    sortable: true,
};
const respostas: TableField = {
    key: "atributos",
    label: "Respostas",
    tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
}

export const fieldsRespostasSerigy: TableField[] = [
    criterioIdItem,
    criterioDs,
    respostas,
    validations,
];
